import { reactive } from "@vue/composition-api";
import axios from "axios";
import router from "@/router";

export default function companyRecruitmentStore() {
  type state = {};
  const state = reactive({
    loading: false,
    prefectures: [] as any,
    prefectureName: [''] as any,
    prefecturesCompany: [] as any,
    municipalities: [] as any,
    municipalitiName: [] as any,
    addressPostal: '' as any,
    checkButton: true,
    checkAllButton: false,
    companyRecuitmentError: {
      status: 200
    },
    jobSearchInfor: {
      dateFrom: '',
      dateTo: '',
      menu1: false,
      menu2: false,
      prefecture: '',
      prefectureCode: '',
      prefectures: [] as any,
      jobPostingStatus: '',
      listJobPostingStatus: ['', '承認前', '掲載前', '掲載中', '掲載終了'],
      dialog: false,
      deleteButton: true,
      checkAllButton: true,
      selected: [] as any,
      checkCardExpired: true,
      headers: [
        { text: "", value: "", align: 'center' , sortable: false},
        { text: "求人名", value: "business_name", align: 'center'},
        { text: "勤務地", value: "prefecture_name", align: 'center' },
        { text: "勤務日", value: "work_start_date", align: 'center' },
        { text: "求人状況", value: "state", align: 'center' },
        { text: "募集人数", value: "capacity", align: 'center' },
        { text: "応募人数", value: "recruitment", align: 'center' },
        { text: "採用残人数", value: "no_remain_recruitment", align: 'center' },
        { text: "詳細", value: "detail", align: 'center', sortable: false }
      ],
      values: [] as any,
      noResultText: null as any,
      pageCount: 0
    },
    createJobInfor: {
      createJobData: {
        business_name: '',
        work_start_date: '',
        work_end_date: '',
        posting_start_date: '',
        posting_end_date: '',
        start_time: '',
        end_time: '',
        postal_code1: '',
        postal_code2: '',
        prefecture_code: '',
        city_code: '',
        prefecture_name: '',
        city_name: '',
        address: '',
        transportation: '',
        salary: '' as any,
        transportation_flg: '有り' as any,
        transportation_fee: '' as any,
        break_time: '有り' as any,
        image1: '' as any,
        image2: '',
        image3: '',
        job_description: '',
        remarks: '',
        capacity: '',
        contact_user: '',
        telephone_no1: '',
        telephone_no2: '',
        telephone_no3: '',
        contact_information_user: ''
      },
      totalPayment: '' as any,
      dialogFeature: false,
      dialogSkill: false,
      dialogJobSearch: false,
      prefectures: [] as any,
      addressInfor: {} as any,
      municipalities: [] as any,
      disabledAmount: false,
      disableTransCost: false,
      menuTime1: false,
      menuTime2: false,
      items: ['有り', '無し'],
      menu: false,
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      maxcomPostalCodeFrom: 3,
      maxcomPostalCodeTo: 4,
      titleJobInformation: '求人情報'
    },
    jobInforDetail: {
      jobInformation: {
        business_name: '',
        work_start_date: '',
        work_end_date: '',
        posting_start_date: '',
        posting_end_date: '',
        salary: 0 as any,
        transportation_flg: '' as any,
        transportation_fee: 0 as any,
        break_time: '' as any,
        media_id_1: '',
        media_id_2: '',
        media_id_3: '',
        job_description: '',
        remarks: '',
        capacity: '',
        contact_information_user: '',
        contact_information_tel: '',
        start_time: '',
        end_time: '',
        postal_code1: '',
        postal_code2: '',
        prefecture_code: '',
        city_code: '',
        prefecture_name: '',
        city_name: '',
        address: '',
        transportation: '',
        contact_user: '',
        telephone_no1: '',
        telephone_no2: '',
        telephone_no3: '',
        common_id: '',
        company_id: '',
        job_information_id: '',
        draft_flg: '' as any,
        public_flg: -1,
      },
      workingTime: {
        start_time: '',
        end_time: ''
      },
      workLocation: {
        address_id: '',
        postal_code: '' as any,
        prefecture_code: '',
        city_code: '',
        address: '',
        transportation: '',
        prefecture_name: ''
      },
      jobType: [] as any,
      jobTypeList: [] as any,
      jobFeature: [] as any,
      jobFeatureList: [] as any,
      jobSkill: [] as any,
      jobSkillList: [] as any,
      showImage1: false,
      showImage2: false,
      showImage3: false,
      compareImage1: '',
      compareImage2: '',
      compareImage3: '',
      prefectures: [] as any,
      addressInfor: {} as any,
      transportationItem: '有り',
      transportationItems: ['有り', '無し'],
      disableTransCost: false,
      dialogFeature: false,
      dialogSkill: false,
      dialogSignUp: false,
      dialogJobSearch: false,
      cityName: '',
      cityCode: '',
      municipalities: [] as any,
      disabledAmount: false,
      totalPayment: '' as any,
      menuTime1: false,
      menuTime2: false,
      items: ['有り', '無し'],
      menu: false,
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
      maxcomPostalCodeFrom: 3,
      maxcomPostalCodeTo: 4,
      showPostalError: false,
      disableBtn: true,
      disableDatePicker: true,
      showlistApplication: true,
      showBtnSignUp: false,
      titleJobInformation: '求人情報',
    },
    jobDetailApplication: {
      showTable: true,
      dialogSignUp: false,
      dialogProgress: false,
      menuRegistration: false,
      items: ['有り', '無し'],
      menu: false,
      customerId: '',
      dateRegistration: ' ',
      evaluation: ['1', '2', '3', '4', '5'],
      listDate: [] as any,
      titleListEvaluation: '応募者一覧',
      startDate: '',
      headers: [
        { text: "ユーザー名", value: "cyurica_num", align: 'center' },
        { text: "勤務日", value: "work_start_date", align: 'center', sortable: false },
        { text: "勤務時間", value: "start_time", align: 'center', sortable: false },
        { text: "勤務地", value: "prefecture_name", align: 'center', sortable: false },
        { text: "ステータス	", value: "status", align: 'center', sortable: false },
        { text: "本人確認", value: "identity_flg", align: 'center', sortable: false },
        { text: "修正・欠勤", value: "correction", align: 'center', sortable: false },
        { text: "評価", value: "evaluation_code", align: 'center', sortable: false },
        { text: "コメント", value: "comment", align: 'center', sortable: false },
        { text: "評価登録", value: "update", align: 'center', sortable: false },
      ],
      values: [] as any,
    },
    jobSaveDraft: {
      dialog: false,
      deleteButton: true,
      checkAllButton: true,
      selected: [] as any,
      checkCardExpired: true,
      headers: [
        { text: "", value: "", align: 'center', sortable: false },
        { text: "求人名", value: "business_name", align: 'center' },
        { text: "勤務地", value: "prefecture_name", align: 'center', sortable: false },
        { text: "勤務日", value: "work_start_date", align: 'center', sortable: false },
        { text: "詳細", value: "detail", align: 'center', sortable: false },
      ],
      values: [] as any,
      noResultText: null as any
    },
    featureSearch: {
      selected: [] as any,
      data: [] as any,
      openDialog: false,
      allSelected: false,
      allFeature: [] as any
    },
    jobSearch: {
      data: [] as any,
      selected: [] as any,
      openDialog: false,
      allJob: [] as any,
      panel: [0, 1] as any,
    },
    skillSearch: {
      selected: [] as any,
      data: [] as any,
      allSelected: false,
      openDialog: false,
      allSkill: [] as any
    },

  });

  let createFd = new FormData()
  let jobFormData = new FormData()
  const axiosinstance = axios.create({
    baseURL: process.env.VUE_APP_API_SERVER
  });
  axiosinstance.interceptors.response.use(
    // 2XX範囲内のステータスコード
    (response) => {
      return response;
    },
    // 2XX範囲外のステータスコード
    (error) => {
      var response = error.response
      const isTimeOut = error.code === "ECONNABORTED";
      if (isTimeOut) {
        state.loading = false;
        router.push("/timeout-error");
        return error;
      }
      if (!error.response) {
        state.loading = false;
        router.push("/network-error");
        return error;
      }else if(response && (response.status == 401 || response.status == 500)){
        localStorage.clear()
        router.push("/");
      } else {
        state.loading = false;
        state.companyRecuitmentError = error.response;
      }
    }
  );

  return {

    get companyRecuitmentError() {
      return state.companyRecuitmentError
    },
    get jobSearchInfor() {
      return state.jobSearchInfor
    },
    get createJobInfor() {
      return state.createJobInfor
    },
    get jobInforDetail() {
      return state.jobInforDetail
    },
    get jobDetailApplication() {
      return state.jobDetailApplication
    },
    get jobSaveDraft() {
      return state.jobSaveDraft
    },
    get featureSearch() {
      return state.featureSearch
    },
    get jobSearch() {
      return state.jobSearch
    },
    get skillSearch() {
      return state.skillSearch
    },
    get loading() {
      return state.loading
    },
    get selected() {
      return state.jobSearchInfor.selected
    },
    get prefectures() {
      return state.prefectures
    },
    get prefectureName() {
      return state.prefectureName
    },

    get prefecturesCompany() {
      return state.prefecturesCompany
    },

    get municipalities() {
      return state.municipalities
    },
    get municipalitiName() {
      return state.municipalitiName
    },

    get addressPostal() {
      return state.addressPostal
    },
    get totalPaymentCreateJob() {
      state.createJobInfor.totalPayment = +state.createJobInfor.createJobData.salary + +state.createJobInfor.createJobData.transportation_fee
      return state.createJobInfor.totalPayment
    },

    get jobDetailTotalPayment() {
      state.jobInforDetail.totalPayment = +state.jobInforDetail.jobInformation.salary + +state.jobInforDetail.jobInformation.transportation_fee
      return state.jobInforDetail.totalPayment
    },

    get stateDeleteJob() {
      return state.jobSearchInfor.selected.length === 0 ? true : false
    },

    get stateDraftDeleteJob() {
      return state.jobSaveDraft.selected.length === 0 ? true : false
    },


    setWorkStartDate(item: string) {
      state.jobSearchInfor.dateFrom = item
    },
    setWorkEndDate(item: string) {
      state.jobSearchInfor.dateTo = item
    },
    setPreFectureCode(item: string) {
      state.prefectures.map((item: any) => {
        if (item.prefecture_code == item) {
          item = item.prefecture_name
        }
      })
      state.jobSearchInfor.prefecture = item
    },
    setJobPostingStatus(item: string) {
      state.jobSearchInfor.jobPostingStatus = item
    },

    inputSalary(e: string) {
      state.createJobInfor.createJobData.salary = e
    },
    inputFee(e: string) {
      state.createJobInfor.createJobData.transportation_fee = e
    },
    inputDetailSalary(e: string) {
      state.jobInforDetail.jobInformation.salary = e
    },
    inputDetailFee(e: string) {
      state.jobInforDetail.jobInformation.transportation_fee = e
    },

    inputSearchDateFrom(e: string) {
      state.jobSearchInfor.dateFrom = e
    },

    inputSearchDateTo(e: string) {
      state.jobSearchInfor.dateTo = e
    },

    inputDetailDateFrom(e: string) {
      state.jobInforDetail.jobInformation.work_start_date = e
    },

    inputDetailDateTo(e: string) {
      state.jobInforDetail.jobInformation.work_end_date = e
    },

    inputPostDateFrom(e: string) {
      state.jobInforDetail.jobInformation.posting_start_date = e
    },

    inputPostDateTo(e: string) {
      state.jobInforDetail.jobInformation.posting_end_date = e
    },

    inputDetailAppicationDate(e: string) {
      state.jobDetailApplication.startDate = e
    },

    inputCreateDateFrom(e: string) {
      state.createJobInfor.createJobData.work_start_date = e
    },

    inputCreateDateTo(e: string) {
      state.createJobInfor.createJobData.work_end_date = e
    },

    inputCreatePostDateFrom(e: string) {
      state.createJobInfor.createJobData.posting_start_date = e
    },

    inputCreatePostDateTo(e: string) {
      state.createJobInfor.createJobData.posting_end_date = e
    },

    setCheckButtonFalse() {
      state.checkButton = false
    },
    setCheckButtonTrue() {
      state.checkButton = true
    },
    get checkButton() {
      return state.checkButton
    },

    setCheckAllButtonFalse() {
      state.checkAllButton = false
    },
    setCheckAllButtonTrue() {
      state.checkAllButton = true
    },
    get checkAllButton() {
      return state.checkAllButton
    },

    clearTableSelected() {
      state.jobSearchInfor.selected = []
      state.jobSaveDraft.selected = []
    },

    resetTableValue() {
      state.jobSearchInfor.values = []
      state.jobSearchInfor.dateFrom = ''
      state.jobSearchInfor.dateTo = ''
      state.jobSearchInfor.jobPostingStatus = ''
      state.jobSearchInfor.prefecture = ''
      state.jobSaveDraft.values = []
      state.jobSearchInfor.selected = []
      state.jobSaveDraft.selected = []
      state.jobSearchInfor.deleteButton = true
    },

    resetBtnSelectAll() {
      state.jobSearchInfor.selected = []
    },

    clearCreateJobParams() {
      state.createJobInfor.createJobData.business_name = ''
      state.createJobInfor.createJobData.work_start_date = ''
      state.createJobInfor.createJobData.work_end_date = '',
      state.createJobInfor.createJobData.posting_start_date = '',
      state.createJobInfor.createJobData.posting_end_date = '',
      state.createJobInfor.createJobData.start_time = '',
      state.createJobInfor.createJobData.end_time = '',
      state.createJobInfor.createJobData.postal_code1 = '',
      state.createJobInfor.createJobData.postal_code2 = '',
      state.createJobInfor.createJobData.prefecture_code = '',
      state.createJobInfor.createJobData.city_code = '',
      state.createJobInfor.createJobData.prefecture_name = '',
      state.createJobInfor.createJobData.city_name = '',
      state.createJobInfor.createJobData.address = '',
      state.createJobInfor.createJobData.transportation = '',
      state.createJobInfor.createJobData.salary = '',
      state.createJobInfor.createJobData.transportation_flg = '有り',
      state.createJobInfor.createJobData.transportation_fee = '',
      state.createJobInfor.createJobData.break_time = '有り',
      state.createJobInfor.createJobData.image1 = '',
      state.createJobInfor.createJobData.image2 = '',
      state.createJobInfor.createJobData.image3 = '',
      state.createJobInfor.createJobData.job_description = '',
      state.createJobInfor.createJobData.remarks = '',
      state.createJobInfor.createJobData.capacity = '',
      state.createJobInfor.createJobData.contact_user = '',
      state.createJobInfor.createJobData.telephone_no1 = '',
      state.createJobInfor.createJobData.telephone_no2 = '',
      state.createJobInfor.createJobData.telephone_no3 = '',
      state.createJobInfor.createJobData.contact_information_user = '',
      state.featureSearch.selected = [],
      state.skillSearch.selected = [],
      state.jobSearch.selected = [],
      state.createJobInfor.disableTransCost = false
    },

    clearDetailJobParams() {
      state.jobInforDetail.jobInformation.business_name = ''
      state.jobInforDetail.jobInformation.work_start_date = ''
      state.jobInforDetail.jobInformation.work_end_date = '',
      state.jobInforDetail.jobInformation.posting_start_date = '',
      state.jobInforDetail.jobInformation.posting_end_date = '',
      state.jobInforDetail.workingTime.start_time = '',
      state.jobInforDetail.workingTime.end_time = '',
      state.jobInforDetail.workLocation.postal_code = '',
      state.jobInforDetail.workLocation.prefecture_code = '',
      state.jobInforDetail.workLocation.city_code = '',
      state.jobInforDetail.workLocation.prefecture_name = '',
      state.jobInforDetail.workLocation.transportation = '',
      state.jobInforDetail.cityName = '',
      state.jobInforDetail.workLocation.address = '',
      state.jobInforDetail.jobInformation.transportation = '',
      state.jobInforDetail.jobInformation.salary = '',
      state.jobInforDetail.jobInformation.transportation_flg = '有り',
      state.jobInforDetail.jobInformation.transportation_fee = '',
      state.jobInforDetail.jobInformation.break_time = '有り',
      state.jobInforDetail.jobInformation.media_id_1 = '',
      state.jobInforDetail.jobInformation.media_id_2 = '',
      state.jobInforDetail.jobInformation.media_id_3 = '',
      state.jobInforDetail.jobInformation.job_description = '',
      state.jobInforDetail.jobInformation.remarks = '',
      state.jobInforDetail.jobInformation.capacity = '',
      state.jobInforDetail.jobInformation.contact_user = '',
      state.jobInforDetail.jobInformation.contact_information_tel = '',
      state.jobInforDetail.jobInformation.contact_information_user = '',
      state.featureSearch.selected = [],
      state.skillSearch.selected = [],
      state.jobSearch.selected = [],
      state.jobInforDetail.disableTransCost = false,
      state.jobDetailApplication.values = [],
      state.jobInforDetail.jobInformation.draft_flg = ''
      state.jobDetailApplication.showTable = true
    },

    onFilePicked1(event: any) {
      const files = event.target.files
      const fileReader = new FileReader()
      fileReader.readAsDataURL(files[0])
      state.createJobInfor.createJobData.image1 = files[0]
      createFd.append('image1', files[0])
    },

    onFilePicked2(event: any) {
      const files = event.target.files
      const fileReader = new FileReader()
      fileReader.readAsDataURL(files[0])
      state.createJobInfor.createJobData.image2 = files[0]
      createFd.append('image2', files[0])
    },

    onFilePicked3(event: any) {
      const files = event.target.files
      const fileReader = new FileReader()
      fileReader.readAsDataURL(files[0])
      state.createJobInfor.createJobData.image3 = files[0]
      createFd.append('image3', files[0])
    },

    detailFilePicked1(event: any) {
      const files = event.target.files
      const fileReader = new FileReader()
      fileReader.readAsDataURL(files[0])
      state.jobInforDetail.jobInformation.media_id_1 = files[0].name
      jobFormData.append('image1', files[0])
    },

    detailFilePicked2(event: any) {
      const files = event.target.files
      const fileReader = new FileReader()
      fileReader.readAsDataURL(files[0])
      state.jobInforDetail.jobInformation.media_id_2 = files[0].name
      jobFormData.append('image2', files[0])
    },

    detailFilePicked3(event: any) {
      const files = event.target.files
      const fileReader = new FileReader()
      fileReader.readAsDataURL(files[0])
      state.jobInforDetail.jobInformation.media_id_3 = files[0].name
      jobFormData.append('image3', files[0])
    },

    deleteImage(index: any) {
      if (index == 1) {
        state.createJobInfor.createJobData.image1 = ''
        state.jobInforDetail.jobInformation.media_id_1 = ''
        state.jobInforDetail.showImage1 = true
        jobFormData.append('delete_image1', '1')
        createFd.delete('image1')
        jobFormData.delete('image1')
      } else if (index == 2) {
        state.createJobInfor.createJobData.image2 = ''
        state.jobInforDetail.jobInformation.media_id_2 = ''
        state.jobInforDetail.showImage2 = true
        jobFormData.append('delete_image2', '1')
        createFd.delete('image2')
        jobFormData.delete('image2')
      } else if (index == 3) {
        state.createJobInfor.createJobData.image3 = ''
        state.jobInforDetail.jobInformation.media_id_3 = ''
        state.jobInforDetail.showImage3 = true
        jobFormData.append('delete_image3', '1')
        createFd.delete('image3')
        jobFormData.delete('image3')
      }
    },

    jobDuplicate() {
      state.jobInforDetail.showBtnSignUp = true
      state.jobInforDetail.disableBtn = false
      state.jobInforDetail.disableDatePicker = false
      state.jobInforDetail.showlistApplication = false
      state.jobDetailApplication.showTable = false
      state.jobInforDetail.jobInformation.work_start_date = ''
      state.jobInforDetail.jobInformation.work_end_date = ''
      state.jobInforDetail.jobInformation.posting_start_date = ''
      state.jobInforDetail.jobInformation.posting_end_date = ''
    },

    addJob(draftFlg: any) {
      return new Promise(resolve => {
        state.loading = true
        if (state.createJobInfor.createJobData.break_time === '有り') {
          state.createJobInfor.createJobData.break_time = 1
        } else if (state.createJobInfor.createJobData.break_time === '無し') {
          state.createJobInfor.createJobData.break_time = 0
        }
        if (state.createJobInfor.createJobData.transportation_flg === '有り') {
          state.createJobInfor.createJobData.transportation_flg = 1
        } else if (state.createJobInfor.createJobData.transportation_flg === '無し') {
          state.createJobInfor.createJobData.transportation_flg = 0
          state.createJobInfor.createJobData.transportation_fee = 0
        }
        state.prefectures.map((item: any) => {
          if (state.createJobInfor.createJobData.prefecture_name === item.prefecture_name) {
            state.createJobInfor.createJobData.prefecture_name = item.prefecture_code
          }
        })
        state.municipalities.map((item: any) => {
          if (state.createJobInfor.createJobData.city_name === item.city_name) {
            state.createJobInfor.createJobData.city_name = item.city_code
          }
        })
        createFd.append('business_name', state.createJobInfor.createJobData.business_name)
        createFd.append('work_start_date', state.createJobInfor.createJobData.work_start_date)
        createFd.append('work_end_date', state.createJobInfor.createJobData.work_end_date)
        createFd.append('posting_start_date', state.createJobInfor.createJobData.posting_start_date)
        createFd.append('posting_end_date', state.createJobInfor.createJobData.posting_end_date)
        createFd.append('start_time', state.createJobInfor.createJobData.start_time)
        createFd.append('end_time', state.createJobInfor.createJobData.end_time)
        createFd.append('postal_code1', state.createJobInfor.createJobData.postal_code1)
        createFd.append('postal_code2', state.createJobInfor.createJobData.postal_code2)
        createFd.append('prefecture_code', state.createJobInfor.createJobData.prefecture_name)
        createFd.append('city_code', state.createJobInfor.createJobData.city_name)
        createFd.append('address', state.createJobInfor.createJobData.address)
        createFd.append('transportation', state.createJobInfor.createJobData.transportation)
        createFd.append('transportation_flg', state.createJobInfor.createJobData.transportation_flg)
        createFd.append('salary', state.createJobInfor.createJobData.salary)
        createFd.append('transportation_fee', state.createJobInfor.createJobData.transportation_fee)
        createFd.append('break_time', state.createJobInfor.createJobData.break_time)
        createFd.append('job_description', state.createJobInfor.createJobData.job_description)
        createFd.append('remarks', state.createJobInfor.createJobData.remarks)
        createFd.append('capacity', state.createJobInfor.createJobData.capacity)
        createFd.append('contact_user', state.createJobInfor.createJobData.contact_information_user)
        createFd.append('telephone_no1', state.createJobInfor.createJobData.telephone_no1)
        createFd.append('telephone_no2', state.createJobInfor.createJobData.telephone_no2)
        createFd.append('telephone_no3', state.createJobInfor.createJobData.telephone_no3)
        createFd.append('draft_flg', draftFlg)
        if (state.jobSearch.selected) {
          state.jobSearch.selected.map((item: any, index: any) => {
            createFd.append(`job_list[${index}]`, `{
            "job_major_code": ${JSON.stringify(item.job_major_code)},
            "job_middle_code": ${JSON.stringify(item.job_middle_code)},
            "job_small_code": ${JSON.stringify(item.job_small_code)},
            "job_small_name": ${JSON.stringify(item.job_small_name)}
          }`)
          })
        }
        if (state.skillSearch.selected) {
          state.skillSearch.selected.map((item: any, index: any) => {
            createFd.append(`skill_list[${index}]`, `{
            "skill_major_code": ${JSON.stringify(item.major_code)},
            "skill_small_code": ${JSON.stringify(item.small_code)},
            "skill_small_name": ${JSON.stringify(item.small_name)}
          }`)
          })
        }
        if (state.featureSearch.selected) {
          state.featureSearch.selected.map((item: any, index: any) => {
            createFd.append(`feature_list[${index}]`, `{
              "feature_major_code": ${JSON.stringify(item.major_code)},
              "feature_small_code": ${JSON.stringify(item.small_code)},
              "feature_small_name": ${JSON.stringify(item.small_name)}
            }`)
          })
        }
        axiosinstance
          .post(
            "company/v0/job",
            createFd,
            {
              headers: {
                "content-type": "multipart/form-data",
                "Authorization": localStorage.getItem("token"),
              }
            }
          )
          .then(response => {
            return !response
              ? resolve(state.companyRecuitmentError)
              : resolve(
                this.searchJob('', '', '', '')
              );
          })
          .then(() => {
            state.loading = false
          })
      })
    },


    updateJobInfor(draftFlg: any) {
      return new Promise(resolve => {
        state.loading = true
        if (state.jobInforDetail.jobInformation.break_time === '有り') {
          state.jobInforDetail.jobInformation.break_time = 1
        } else if (state.jobInforDetail.jobInformation.break_time === '無し') {
          state.jobInforDetail.jobInformation.break_time = 0
        }
        if (state.jobInforDetail.jobInformation.transportation_flg === '有り') {
          state.jobInforDetail.jobInformation.transportation_flg = 1
        } else if (state.jobInforDetail.jobInformation.transportation_flg === '無し') {
          state.jobInforDetail.jobInformation.transportation_flg = 0
          state.jobInforDetail.jobInformation.transportation_fee = 0
        }
        state.prefectures.map((item: any) => {
          if (state.jobInforDetail.workLocation.prefecture_name === item.prefecture_name) {
            state.jobInforDetail.workLocation.prefecture_name = item.prefecture_code
          }
        })
        state.municipalities.map((item: any) => {
          if (state.jobInforDetail.cityName === item.city_name) {
            state.jobInforDetail.cityName = item.city_code
          }
        })
        jobFormData.append('common_id', state.jobInforDetail.jobInformation.common_id)
        jobFormData.append('business_name', state.jobInforDetail.jobInformation.business_name)
        jobFormData.append('work_start_date', state.jobInforDetail.jobInformation.work_start_date)
        jobFormData.append('work_end_date', state.jobInforDetail.jobInformation.work_end_date)
        jobFormData.append('posting_start_date', state.jobInforDetail.jobInformation.posting_start_date)
        jobFormData.append('posting_end_date', state.jobInforDetail.jobInformation.posting_end_date)
        jobFormData.append('start_time', state.jobInforDetail.workingTime.start_time)
        jobFormData.append('end_time', state.jobInforDetail.workingTime.end_time)
        jobFormData.append('postal_code1', state.jobInforDetail.workLocation.postal_code[0])
        jobFormData.append('postal_code2', state.jobInforDetail.workLocation.postal_code[1])
        jobFormData.append('prefecture_code', state.jobInforDetail.workLocation.prefecture_name)
        jobFormData.append('city_code', state.jobInforDetail.cityName)
        jobFormData.append('address', state.jobInforDetail.workLocation.address)
        jobFormData.append('transportation', state.jobInforDetail.workLocation.transportation)
        jobFormData.append('transportation_flg', state.jobInforDetail.jobInformation.transportation_flg)
        jobFormData.append('salary', state.jobInforDetail.jobInformation.salary)
        jobFormData.append('transportation_fee', state.jobInforDetail.jobInformation.transportation_fee)
        jobFormData.append('break_time', state.jobInforDetail.jobInformation.break_time)
        jobFormData.append('job_description', state.jobInforDetail.jobInformation.job_description)
        jobFormData.append('remarks', state.jobInforDetail.jobInformation.remarks)
        jobFormData.append('capacity', state.jobInforDetail.jobInformation.capacity)
        jobFormData.append('contact_user', state.jobInforDetail.jobInformation.contact_information_user)
        jobFormData.append('telephone_no1', state.jobInforDetail.jobInformation.contact_information_tel[0])
        jobFormData.append('telephone_no2', state.jobInforDetail.jobInformation.contact_information_tel[1])
        jobFormData.append('telephone_no3', state.jobInforDetail.jobInformation.contact_information_tel[2])
        jobFormData.append('draft_flg', draftFlg)
        if (state.jobSearch.selected) {
          state.jobSearch.selected.map((item: any, index: any) => {
            jobFormData.append(`job_list[${index}]`, `{
          "job_major_code": ${JSON.stringify(item.job_major_code)},
          "job_middle_code": ${JSON.stringify(item.job_middle_code)},
          "job_small_code": ${JSON.stringify(item.job_small_code)},
          "job_small_name": ${JSON.stringify(item.job_small_name)}
        }`)
          })
        }
        if (state.skillSearch.selected) {
          state.skillSearch.selected.map((item: any, index: any) => {
            jobFormData.append(`skill_list[${index}]`, `{
          "skill_major_code": ${JSON.stringify(item.major_code)},
          "skill_small_code": ${JSON.stringify(item.small_code)},
          "skill_small_name": ${JSON.stringify(item.small_name)}
        }`)
          })
        }
        if (state.featureSearch.selected) {
          state.featureSearch.selected.map((item: any, index: any) => {
            jobFormData.append(`feature_list[${index}]`, `{
            "feature_major_code": ${JSON.stringify(item.major_code)},
            "feature_small_code": ${JSON.stringify(item.small_code)},
            "feature_small_name": ${JSON.stringify(item.small_name)}
          }`)
          })
        }
        axiosinstance
          .put(
            "company/v0/job",
            jobFormData,
            {
              headers: {
                "content-type": "multipart/form-data",
                "Authorization": localStorage.getItem("token"),
              }
            }
          )
          .then(response => {
            return !response
              ? resolve(state.companyRecuitmentError)
              : resolve(
                this.searchJob('', '', '', '')
              );
          })
          .then(() => {
            state.loading = false
          })
      })
    },


    changeJobDetailFeeFlag() {
      state.prefectures.map((item: any) => {
        if (item.prefecture_code === state.jobInforDetail.workLocation.prefecture_name) {
          state.jobInforDetail.workLocation.prefecture_name = item.prefecture_name
        }
      })
      if (state.jobInforDetail.cityName) {
        state.municipalities.map((item: any) => {
          if (item.city_code === state.jobInforDetail.cityName) {
            state.jobInforDetail.cityName = item.city_name
          }
        })
      }
      if (state.jobInforDetail.jobInformation.transportation_flg === 0) {
        state.jobInforDetail.jobInformation.transportation_flg = '無し'
        state.jobInforDetail.disableTransCost = true
      } else {
        state.jobInforDetail.jobInformation.transportation_flg = '有り'
        state.jobInforDetail.disableTransCost = false
      }
      if (state.jobInforDetail.jobInformation.break_time === 0) {
        state.jobInforDetail.jobInformation.break_time = "無し"
      } else if (state.jobInforDetail.jobInformation.break_time === 1) {
        state.jobInforDetail.jobInformation.break_time = "有り"
      }
    },

    resetCreteJobFlag() {
      state.prefectures.map((item: any) => {
        if (item.prefecture_code === state.createJobInfor.createJobData.prefecture_name) {
          state.createJobInfor.createJobData.prefecture_name = item.prefecture_name
        }
      })
      if (state.createJobInfor.createJobData.city_name) {
        state.municipalities.map((item: any) => {
          if (item.city_code === state.createJobInfor.createJobData.city_name) {
            state.createJobInfor.createJobData.city_name = item.city_name
          }
        })
      }
      if (state.createJobInfor.createJobData.transportation_flg === 0) {
        state.createJobInfor.createJobData.transportation_flg = '無し'
        state.createJobInfor.disableTransCost = true
      } else {
        state.createJobInfor.createJobData.transportation_flg = '有り'
        state.createJobInfor.disableTransCost = false
      }
      if (state.createJobInfor.createJobData.break_time === 0) {
        state.createJobInfor.createJobData.break_time = "無し"
      } else if (state.createJobInfor.createJobData.break_time === 1) {
        state.createJobInfor.createJobData.break_time = "有り"
      }
    },

    addJobDuplicate(draftFlg: any) {
      return new Promise(resolve => {
        state.loading = true
        if (state.jobInforDetail.jobInformation.break_time === '有り') {
          state.jobInforDetail.jobInformation.break_time = 1
        } else if (state.jobInforDetail.jobInformation.break_time === '無し') {
          state.jobInforDetail.jobInformation.break_time = 0
        }
        if (state.jobInforDetail.jobInformation.transportation_flg === '有り') {
          state.jobInforDetail.jobInformation.transportation_flg = 1
        } else if (state.jobInforDetail.jobInformation.transportation_flg === '無し') {
          state.jobInforDetail.jobInformation.transportation_flg = 0
          state.jobInforDetail.jobInformation.transportation_fee = 0
        }
        state.prefectures.map((item: any) => {
          if (state.jobInforDetail.workLocation.prefecture_name === item.prefecture_name) {
            state.jobInforDetail.workLocation.prefecture_name = item.prefecture_code
          }
        })
        state.municipalities.map((item: any) => {
          if (state.jobInforDetail.cityName === item.city_name) {
            state.jobInforDetail.cityName = item.city_code
          }
        })
        if (state.jobInforDetail.jobInformation.media_id_1 === state.jobInforDetail.compareImage1) {
          jobFormData.append('copy_image1', state.jobInforDetail.jobInformation.media_id_1)
        }
        if (state.jobInforDetail.jobInformation.media_id_2 === state.jobInforDetail.compareImage2) {
          jobFormData.append('copy_image2', state.jobInforDetail.jobInformation.media_id_2)
        }
        if (state.jobInforDetail.jobInformation.media_id_3 === state.jobInforDetail.compareImage3) {
          jobFormData.append('copy_image3', state.jobInforDetail.jobInformation.media_id_3)
        }
        jobFormData.append('business_name', state.jobInforDetail.jobInformation.business_name)
        jobFormData.append('work_start_date', state.jobInforDetail.jobInformation.work_start_date)
        jobFormData.append('work_end_date', state.jobInforDetail.jobInformation.work_end_date)
        jobFormData.append('posting_start_date', state.jobInforDetail.jobInformation.posting_start_date)
        jobFormData.append('posting_end_date', state.jobInforDetail.jobInformation.posting_end_date)
        jobFormData.append('start_time', state.jobInforDetail.workingTime.start_time)
        jobFormData.append('end_time', state.jobInforDetail.workingTime.end_time)
        jobFormData.append('postal_code1', state.jobInforDetail.workLocation.postal_code[0])
        jobFormData.append('postal_code2', state.jobInforDetail.workLocation.postal_code[1])
        jobFormData.append('prefecture_code', state.jobInforDetail.workLocation.prefecture_name)
        jobFormData.append('city_code', state.jobInforDetail.cityName)
        jobFormData.append('address', state.jobInforDetail.workLocation.address)
        jobFormData.append('transportation', state.jobInforDetail.workLocation.transportation)
        jobFormData.append('transportation_flg', state.jobInforDetail.jobInformation.transportation_flg)
        jobFormData.append('salary', state.jobInforDetail.jobInformation.salary)
        jobFormData.append('transportation_fee', state.jobInforDetail.jobInformation.transportation_fee)
        jobFormData.append('break_time', state.jobInforDetail.jobInformation.break_time)
        jobFormData.append('job_description', state.jobInforDetail.jobInformation.job_description)
        jobFormData.append('remarks', state.jobInforDetail.jobInformation.remarks)
        jobFormData.append('capacity', state.jobInforDetail.jobInformation.capacity)
        jobFormData.append('contact_user', state.jobInforDetail.jobInformation.contact_information_user)
        jobFormData.append('telephone_no1', state.jobInforDetail.jobInformation.contact_information_tel[0])
        jobFormData.append('telephone_no2', state.jobInforDetail.jobInformation.contact_information_tel[1])
        jobFormData.append('telephone_no3', state.jobInforDetail.jobInformation.contact_information_tel[2])
        jobFormData.append('draft_flg', draftFlg)
        if (state.jobSearch.selected) {
          state.jobSearch.selected.map((item: any, index: any) => {
            jobFormData.append(`job_list[${index}]`, `{
            "job_major_code": ${JSON.stringify(item.job_major_code)},
            "job_middle_code": ${JSON.stringify(item.job_middle_code)},
            "job_small_code": ${JSON.stringify(item.job_small_code)},
            "job_small_name": ${JSON.stringify(item.job_small_name)}
          }`)
          })
        }
        if (state.featureSearch.selected) {
          state.skillSearch.selected.map((item: any, index: any) => {
            jobFormData.append(`skill_list[${index}]`, `{
            "skill_major_code": ${JSON.stringify(item.major_code)},
            "skill_small_code": ${JSON.stringify(item.small_code)},
            "skill_small_name": ${JSON.stringify(item.small_name)}
          }`)
          })
        }
        if (state.featureSearch.selected) {
          state.featureSearch.selected.map((item: any, index: any) => {
            jobFormData.append(`feature_list[${index}]`, `{
              "feature_major_code": ${JSON.stringify(item.major_code)},
              "feature_small_code": ${JSON.stringify(item.small_code)},
              "feature_small_name": ${JSON.stringify(item.small_name)}
            }`)
          })
        }
        axiosinstance
          .post(
            "company/v0/job",
            jobFormData,
            {
              headers: {
                "content-type": "multipart/form-data",
                "Authorization": localStorage.getItem("token"),
              }
            }
          )
          .then(response => {
            return !response
              ? resolve(state.companyRecuitmentError)
              : resolve(
                this.searchJob('', '', '', '')
              );
          })
          .then(() => {
            state.loading = false
          })
      })
    },

    clearJobFormData() {
      jobFormData.delete('common_id')
      jobFormData.delete('business_name')
      jobFormData.delete('work_start_date')
      jobFormData.delete('work_end_date')
      jobFormData.delete('posting_start_date')
      jobFormData.delete('posting_end_date')
      jobFormData.delete('start_time')
      jobFormData.delete('end_time')
      jobFormData.delete('postal_code1')
      jobFormData.delete('postal_code2')
      jobFormData.delete('prefecture_code')
      jobFormData.delete('city_code')
      jobFormData.delete('address')
      jobFormData.delete('transportation')
      jobFormData.delete('transportation_flg')
      jobFormData.delete('salary')
      jobFormData.delete('transportation_fee')
      jobFormData.delete('break_time')
      jobFormData.delete('job_description')
      jobFormData.delete('remarks')
      jobFormData.delete('capacity')
      jobFormData.delete('contact_user')
      jobFormData.delete('telephone_no1')
      jobFormData.delete('telephone_no2')
      jobFormData.delete('telephone_no3')
      jobFormData.delete('draft_flg')
      if (state.jobSearch.selected) {
        state.jobSearch.selected.map((item: any, index: any) => {
          jobFormData.delete(`job_list[${index}]`)
        })
      }
      if (state.featureSearch.selected) {
        state.skillSearch.selected.map((item: any, index: any) => {
          jobFormData.delete(`skill_list[${index}]`)
        })
      }
      if (state.featureSearch.selected) {
        state.featureSearch.selected.map((item: any, index: any) => {
          jobFormData.delete(`feature_list[${index}]`)
        })
      }
      jobFormData.delete('copy_image1')
      jobFormData.delete('copy_image2')
      jobFormData.delete('copy_image3')
      jobFormData.delete('image1')
      jobFormData.delete('image2')
      jobFormData.delete('image3')
      jobFormData.delete('delete_image1')
      jobFormData.delete('delete_image2')
      jobFormData.delete('delete_image3')
    },

    clearCreateFormData() {
      createFd.delete('business_name')
      createFd.delete('work_start_date')
      createFd.delete('work_end_date')
      createFd.delete('posting_start_date')
      createFd.delete('posting_end_date')
      createFd.delete('start_time')
      createFd.delete('end_time')
      createFd.delete('postal_code1')
      createFd.delete('postal_code2')
      createFd.delete('prefecture_code')
      createFd.delete('city_code')
      createFd.delete('address')
      createFd.delete('transportation')
      createFd.delete('transportation_flg')
      createFd.delete('salary')
      createFd.delete('transportation_fee')
      createFd.delete('break_time')
      createFd.delete('job_description')
      createFd.delete('remarks')
      createFd.delete('capacity')
      createFd.delete('contact_user')
      createFd.delete('telephone_no1')
      createFd.delete('telephone_no2')
      createFd.delete('telephone_no3')
      createFd.delete('draft_flg')
      if (state.jobSearch.selected) {
        state.jobSearch.selected.map((item: any, index: any) => {
          createFd.delete(`job_list[${index}]`)
        })
      }
      if (state.featureSearch.selected) {
        state.skillSearch.selected.map((item: any, index: any) => {
          createFd.delete(`skill_list[${index}]`)
        })
      }
      if (state.featureSearch.selected) {
        state.featureSearch.selected.map((item: any, index: any) => {
          createFd.delete(`feature_list[${index}]`)
        })
      }
      createFd.delete('copy_image1')
      createFd.delete('copy_image2')
      createFd.delete('copy_image3')
      createFd.delete('image1')
      createFd.delete('image2')
      createFd.delete('image3')
      createFd.delete('delete_image1')
      createFd.delete('delete_image2')
      createFd.delete('delete_image3')
    },
    resetNoResultText() {
      state.jobSearchInfor.noResultText = null
    },

    async searchJob(dateFrom: any, dateTo: any, prefecture: any, status: any) {
      state.loading = true
      state.jobSearchInfor.deleteButton = true
      state.jobSearchInfor.values = []
      state.jobSaveDraft.values = []
      state.jobSearchInfor.selected = []
      state.jobSaveDraft.selected = []

      state.prefectures.map((item: any) => {
        if (state.jobSearchInfor.prefecture == '') {
          state.jobSearchInfor.prefectureCode = ''
        }
        if (item.prefecture_name == state.jobSearchInfor.prefecture) {
          state.jobSearchInfor.prefectureCode = item.prefecture_code
        }
      })
      await axiosinstance
        .get(
          `company/v0/job?prefecture_code=${prefecture}&start_work_day=${dateFrom}&end_work_day=${dateTo}`,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token"),
            }
          }
        )
        .then(response => {
          response.data.map((items: any, index: any) => {
            if (items.recruitment == null) {
              items.recruitment = 0
            }
            items.work_start_date = items.work_start_date ? items.work_start_date.replace(/(\d{4})-(\d{2})-(\d{2})/g, '$1/$2/$3') : ''
          })
          if (response.data.length > 0) {
            state.jobSearchInfor.checkAllButton = false
          }
          if (status != '') {
            response.data.map((item: any) => {
              if (item.state == status) {
                state.jobSearchInfor.values.push(item)
              }
            })
          } else {
            state.jobSearchInfor.values = response.data
          }
          let noDraftJob = [] as any
          let draftJob = [] as any
          state.jobSearchInfor.values.map((item: any, index: any) => {
            item.id = index
            if (item.draft_flg == 0) {
              noDraftJob.push(item)
            } else {
              draftJob.push(item)
            }
          })
          state.jobSearchInfor.values = noDraftJob
          state.jobSaveDraft.values = draftJob
          if (state.jobSearchInfor.values.length === 0) {
            state.jobSearchInfor.noResultText = '検索データはありません'
          }
          if (state.jobSaveDraft.values.length === 0) {
            state.jobSaveDraft.noResultText = '検索データはありません'
          }
        })
        .then(() => {
          state.loading = false
          state.prefectures.map((item: any) => {
            if (state.jobSearchInfor.prefecture == '') {
              state.jobSearchInfor.prefecture = ''
            }
            if (item.prefecture_code == state.jobSearchInfor.prefecture) {
              state.jobSearchInfor.prefecture = item.prefecture_name
            }
          })
        });
    },

    clearSearchParams() {
      state.jobSearchInfor.dateFrom = ''
      state.jobSearchInfor.dateTo = ''
      state.jobSearchInfor.prefecture = ''
      state.jobSearchInfor.jobPostingStatus = ''
      state.jobSearchInfor.values = []
      state.jobSearchInfor.selected = []
    },

    searchPostalCode(postal1: any, postal2: any) {
      return new Promise(resolve => {
        const zipCode = postal1 + postal2
        state.loading = true
        axiosinstance
          .get(
            "company/v0/getAddress?zipcode=" + zipCode,
            {
              headers: {
                "content-type": "application/json",
                "Authorization": localStorage.getItem("token")
              }
            }
          )
          .then(response => {
            return !response
              ? resolve(state.companyRecuitmentError)
              : resolve(
                state.addressPostal = response.data
              );
          })
          .then(() => {
            if (state.addressPostal !== '') {
              state.createJobInfor.createJobData.prefecture_name = state.addressPostal.state
              state.createJobInfor.createJobData.city_name = state.addressPostal.city
              state.createJobInfor.createJobData.address = state.addressPostal.town
              state.jobInforDetail.workLocation.address = state.addressPostal.town
              state.jobInforDetail.cityName = state.addressPostal.city
              state.jobInforDetail.workLocation.prefecture_name = state.addressPostal.state
            }
            state.loading = false
          })
      })
    },

    getCityByPostalCode() {
      let prefectureId = '';
      state.prefectures.map((items: any) => {
        if (items.prefecture_name === state.createJobInfor.createJobData.prefecture_name) {
          prefectureId = items.prefecture_code
        }
      })
      axiosinstance
        .get(
          "customer/v0/city?prefecture_code=" + prefectureId,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          state.municipalities = response.data
          response.data.map((value: any) => {
            state.municipalitiName.push(value.city_name)
          })
        })
        .then(() => {
        });

    },

    deleteJob(selected: any) {
      state.loading = true
      let deleteArray = [] as any
      selected.map((item: any) => {
        if (item.recruitment === 0) {
          deleteArray.push({ job_information_id: item.job_information_id, common_id: item.common_id })
        }
      })
      axiosinstance
        .delete(
          "company/v0/job",
          {
            data: deleteArray,
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          state.jobSearchInfor.selected = []
        })
        .then(() => {
          state.loading = false
          deleteArray = []
          state.jobSaveDraft.selected = []
          state.jobSaveDraft.deleteButton = true
          state.prefectures.map((item: any) => {
            if (state.jobSearchInfor.prefecture == '') {
              state.jobSearchInfor.prefecture = ''
            }
            if (item.prefecture_name == state.jobSearchInfor.prefecture) {
              state.jobSearchInfor.prefecture = item.prefecture_code
            }
          })
        })
    },

    async jobSearchInformationDetail(commonId: any, recruitment: any, inStartDate: any = '') {
      state.loading = true
      state.jobInforDetail.showBtnSignUp = false
      state.jobDetailApplication.listDate = []
      await axiosinstance
        .get(
          "company/v0/job?common_id=" + commonId,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          let dateArray = [] as any
          if (response.data.work_start_date === response.data.work_end_date) {
            dateArray.push(response.data.work_start_date)
          } else {
            var startDate = response.data.work_start_date as any;
            var endDate = response.data.work_end_date as any;
            var dateMove = new Date(startDate) as any;
            var strDate = startDate as any;
            while (strDate < endDate) {
              var strDate = dateMove.toISOString().slice(0, 10);
              dateArray.push(strDate);
              dateMove.setDate(dateMove.getDate() + 1);
            };
          }
          dateArray.map((item: any) => {
            if (item !== '') {
              state.jobDetailApplication.listDate.push(item.replace(/(\d{4})-(\d{2})-(\d{2})/g, '$1/$2/$3'))
            }
          })
          state.jobDetailApplication.listDate.unshift('')
          if(inStartDate){
            state.jobDetailApplication.startDate = inStartDate
          }else{
            state.jobDetailApplication.startDate = response.data.work_start_date
          }
          
          if (response.data.media_id_1 === null || response.data.media_id_1 === '') {
            state.jobInforDetail.showImage1 = true
          } else {
            state.jobInforDetail.showImage1 = false
          }
          if (response.data.media_id_2 === null || response.data.media_id_2 === '') {
            state.jobInforDetail.showImage2 = true
          } else {
            state.jobInforDetail.showImage2 = false
          }
          if (response.data.media_id_3 === null || response.data.media_id_3 === '') {
            state.jobInforDetail.showImage3 = true
          } else {
            state.jobInforDetail.showImage3 = false
          }
          if (response.data.transportation_flg === 0) {
            state.jobInforDetail.jobInformation.transportation_flg = '無し'
            state.jobInforDetail.disableTransCost = true
          } else {
            state.jobInforDetail.jobInformation.transportation_flg = '有り'
            state.jobInforDetail.disableTransCost = false
          }
          if (response.data.break_time_flg === 0) {
            state.jobInforDetail.jobInformation.break_time = "無し"
          } else if (response.data.break_time_flg === 1) {
            state.jobInforDetail.jobInformation.break_time = "有り"
          }
          state.jobInforDetail.compareImage1 = response.data.media_id_1
          state.jobInforDetail.compareImage2 = response.data.media_id_2
          state.jobInforDetail.compareImage3 = response.data.media_id_3
          state.jobInforDetail.jobInformation = response.data
          // capacity（定員数）はなぜか一旦Stringに変換しないと初期表示時のvalidatorエラーに引っかかるのでそうする
          state.jobInforDetail.jobInformation.capacity = String(state.jobInforDetail.jobInformation.capacity)
          state.jobInforDetail.jobInformation.contact_information_tel = response.data.contact_information_tel.split('-')
          state.jobInforDetail.totalPayment = +state.jobInforDetail.jobInformation.salary + +state.jobInforDetail.jobInformation.transportation_fee
          if (response.data.transportation_flg === 0) {
            state.jobInforDetail.jobInformation.transportation_flg = '無し'
          } else {
            state.jobInforDetail.jobInformation.transportation_flg = '有り'
          }
          if (response.data.break_time_flg === 0) {
            state.jobInforDetail.jobInformation.break_time = "無し"
          } else if (response.data.break_time_flg === 1) {
            state.jobInforDetail.jobInformation.break_time = "有り"
          }

          var public_flg = response.data.public_flg;
          if (response.data.draft_flg == 1) {
            state.jobInforDetail.disableBtn = false
          }
          else if(public_flg == -1 || public_flg == -2){
            state.jobInforDetail.disableBtn = true
          }
          else if(response.data.apply_count > 0 ){
            state.jobInforDetail.disableBtn = true
          }else{
            state.jobInforDetail.disableBtn = false
          }
          

        })
        .then(() => {
        });
      await axiosinstance
        .get(
          `company/v0/applicationInfo?common_id=${state.jobInforDetail.jobInformation.common_id}&work_date=${state.jobDetailApplication.startDate}`,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          response.data.map((item: any) => {
            if (item.identity_flg == 1) {
              item.identity_flg = true
            } else {
              item.identity_flg = false
            }
            item.work_start_date = item.work_start_date ? item.work_start_date.replace(/(\d{4})-(\d{2})-(\d{2})/g, '$1/$2/$3') : ''
            item.start_time = item.start_time ? item.start_time.slice(0, 5) : ''
            item.end_time = item.end_time ? item.end_time.slice(0, 5) : ''
          })
          state.jobDetailApplication.values = response.data
        })
        .then(() => {
          state.loading = false
        });
    },

    getApplicationInfo(commonId: any, work_date: any) {
      state.loading = true
      axiosinstance
        .get(
          `company/v0/applicationInfo?common_id=${commonId}&work_date=${work_date}`,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          response.data.map((item: any) => {
            if (item.identity_flg == 1) {
              item.identity_flg = true
            } else {
              item.identity_flg = false
            }
            item.work_start_date = item.work_start_date ? item.work_start_date.replace(/(\d{4})-(\d{2})-(\d{2})/g, '$1/$2/$3') : ''
            item.start_time = item.start_time ? item.start_time.slice(0, 5) : ''
            item.end_time = item.end_time ? item.end_time.slice(0, 5) : ''
          })
          state.jobDetailApplication.values = response.data
        })
        .then(() => {
          state.loading = false
        });
    },

    async getJobType(commonId: any) {
      await axiosinstance
        .get(
          `company/v0/jobType?common_id=${commonId}`,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          response.data.map((item: any) => {
            item.job_major_code = item.major_code
            delete item.major_code
            item.job_middle_code = item.middle_code
            delete item.middle_code
            item.job_small_code = item.small_code
            delete item.small_code
            item.job_small_name = item.small_name
            delete item.small_name
          })
          state.jobSearch.selected = response.data
          state.jobSearch.allJob.map((item: any) => {
            state.jobSearch.selected.map((value: any) => {
              if (item.small_code == value.small_code) {
                value.major_name = item.major_name
                value.middle_name = item.middle_name
              }
            })
          })
          state.jobInforDetail.jobType = response.data
          state.jobInforDetail.jobTypeList = response.data.map((item: { small_name: string }) => item.small_name).join("\t")
        })
        .then(() => {
        });
    },

    getJobFeature(commonId: any) {
      axiosinstance
        .get(
          `company/v0/jobFeature?common_id=${commonId}`,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          state.featureSearch.selected = response.data
          state.featureSearch.allFeature.map((item: any) => {
            state.featureSearch.selected.map((value: any) => {
              if (item.small_code == value.small_code) {
                value.major_name = item.major_name
              }
            })
          })
          state.jobInforDetail.jobFeature = response.data
          state.jobInforDetail.jobFeatureList = response.data.map((item: { small_name: string }) => item.small_name).join("\t")
        })
        .then(() => {

        });
    },

    getJobSkill(commonId: any) {
      axiosinstance
        .get(
          `company/v0/jobSkill?common_id=${commonId}`,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          state.skillSearch.selected = response.data
          state.skillSearch.allSkill.map((item: any) => {
            state.skillSearch.selected.map((value: any) => {
              if (item.small_code == value.small_code) {
                value.major_name = item.major_name
              }
            })
          })
          state.jobInforDetail.jobSkill = response.data

          state.jobInforDetail.jobSkillList = response.data.map((item: { small_name: string }) => item.small_name).join("\t")
        })
        .then(() => {
        });
    },

    clearJobSelected() {
      state.jobSearch.selected = [],
        state.skillSearch.selected = [],
        state.featureSearch.selected = []
    },

    getWorkingTime(commonId: any) {
      axiosinstance
        .get(
          "company/v0/shift?common_id=" + commonId,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          response.data.start_time = response.data.start_time ? response.data.start_time.slice(0, 5) : ''
          response.data.end_time = response.data.end_time ? response.data.end_time.slice(0, 5) : ''
          state.jobInforDetail.workingTime = response.data
        })
        .then(() => {
        });
    },

    async getPostalCode(commonId: any) {
      await axiosinstance
        .get(
          "company/v0/address?common_id=" + commonId,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          state.jobInforDetail.workLocation = response.data
          state.jobInforDetail.workLocation.postal_code = response.data.postal_code.split('-')
          state.jobInforDetail.cityCode = response.data.city_code
        })
        .then(() => {
        });
      await axiosinstance
        .get(
          "customer/v0/city?prefecture_code=" + state.jobInforDetail.workLocation.prefecture_code,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          state.municipalities = response.data
          response.data.map((value: any) => {
            state.municipalitiName.push(value.city_name)
          })
          state.municipalities.map((item: any) => {
            if (item.city_code == state.jobInforDetail.cityCode) {
              state.jobInforDetail.cityName = item.city_name
            }
          })
        })
        .then(() => {
        });
    },

    viewJobImage(image_url: any) {
      return window.open(image_url);
    },

    updateUserComment(data: any) {
      state.loading = true
      if (data.identity_flg == true) {
        data.identity_flg = 1
      } else data.identity_flg = 0
      const params = {
        comment_data: data.comment,
        customer_id: data.customer_id,
        evaluation_code: data.evaluation_code,
        job_information_id: data.job_information_id,
        identity_flg: data.identity_flg
      }
      axiosinstance
        .post(
          "company/v0/rating",
          params,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
        })
        .then(() => {
          state.loading = false
        });
    },

    updateAttendance(data: any, attendanceReason:string){
      state.loading = true;
      const params = {
        customer_id: data.customer_id,
        job_information_id: data.job_information_id,
        attendance_reason: attendanceReason
      }
      axiosinstance
        .post(
          "company/v0/attendance",
          params,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          
        })
        .then(() => {
          state.loading = false
        });
    },

    //featureSearch
    featureSelect() {
      if (state.featureSearch.selected.length == state.featureSearch.allFeature.length) {
        state.featureSearch.allSelected = true
      } else {
        state.featureSearch.allSelected = false
      }
    },
    //skillSearch
    skillSelect() {
      if (state.skillSearch.selected.length == state.skillSearch.allSkill.length) {
        state.skillSearch.allSelected = true
      } else {
        state.skillSearch.allSelected = false
      }
    },

    selectTransCost() {
      if (state.jobInforDetail.jobInformation.transportation_flg == '無し') {
        state.jobInforDetail.disableTransCost = true
        state.jobInforDetail.jobInformation.transportation_fee = ''
      } else {
        state.jobInforDetail.disableTransCost = false
      }
      if (state.createJobInfor.createJobData.transportation_flg == '無し') {
        state.createJobInfor.disableTransCost = true
        state.createJobInfor.createJobData.transportation_fee = ''
        state.createJobInfor.totalPayment = state.createJobInfor.createJobData.salary
      } else {
        state.createJobInfor.disableTransCost = false
      }
    },

    skillSelectAll() {
      state.skillSearch.selected = []
      if (state.skillSearch.allSelected) {
        state.skillSearch.selected = state.skillSearch.allSkill
      }
    },

    featureSelectAll() {
      state.featureSearch.selected = []
      if (state.featureSearch.allSelected) {
        state.featureSearch.selected = state.featureSearch.allFeature
      }
    },

    getListPrefecture() {
      axiosinstance
        .get(
          "customer/v0/prefecture",
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          state.createJobInfor.addressInfor = response.data
          state.jobInforDetail.addressInfor = response.data
          state.prefectures = response.data
          response.data.map((value: any) => {
            state.createJobInfor.prefectures.push(value.prefecture_name)
            state.jobInforDetail.prefectures.push(value.prefecture_name)
            state.prefectureName.push(value.prefecture_name)
          })
          state.prefectures.map((item: any) => {
            if (item.prefecture_code == state.jobInforDetail.workLocation.prefecture_code) {
              state.jobInforDetail.workLocation.prefecture_name = item.prefecture_name
            }
          })
          state.prefecturesCompany = response.data.map((item: { prefecture_name: string, prefecture_code: string }) => {
            return { text: item.prefecture_name, value: item.prefecture_code }
          });
          // @ts-ignore
          state.prefecturesCompany.unshift({ text: '', value: '' })
        })
        .then(() => {
        });
    },

    getListCity() {
      state.municipalitiName = []
      let prefectureId = 0;
      state.prefectures.map((items: any) => {
        if (items.prefecture_name === state.createJobInfor.createJobData.prefecture_name) {
          prefectureId = items.prefecture_code
        }
      })
      axiosinstance
        .get(
          "customer/v0/city?prefecture_code=" + prefectureId,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          state.municipalities = response.data
          response.data.map((value: any) => {
            state.createJobInfor.municipalities.push(value.city_name)
            state.jobInforDetail.municipalities.push(value.city_name)
            state.municipalitiName.push(value.city_name)
          })
        })
        .then(() => {
        });
    },

    getDetailListCity() {
      state.jobInforDetail.cityName = ''
      state.municipalitiName = []
      let prefectureId = 0;
      state.prefectures.map((items: any) => {
        if (items.prefecture_name === state.jobInforDetail.workLocation.prefecture_name) {
          prefectureId = items.prefecture_code
        }
      })
      axiosinstance
        .get(
          "customer/v0/city?prefecture_code=" + prefectureId,
          {
            headers: {
              "content-type": "application/json",
              "Authorization": localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          state.municipalities = response.data
          response.data.map((value: any) => {
            state.municipalitiName.push(value.city_name)
          })
          state.municipalities.map((item: any) => {
            if (item.city_code == state.jobInforDetail.cityCode) {
              state.jobInforDetail.cityName = item.city_name
            }
          })
        })
        .then(() => {
        });
    },

    //get job data to render to select dialog
    async renderJobTypeSelect() {
      await axiosinstance
        .get(
          "customer/v0/jobCategory",
          {
            headers: {
              "content-type": "application/json",
            }
          }
        )
        .then(response => {
          state.jobSearch.data = response.data
          state.jobSearch.allJob = response.data
          let jobData = [] as any
          state.jobSearch.data.forEach((a: any) => {
            let array = state.jobSearch.data.filter((b: any) => {
              return (a.job_major_code === b.job_major_code)
            })

            jobData.push({ item: [...array], id: a.job_major_code, name: a.job_major_name })
          })
          state.jobSearch.data = [...new Map(jobData.map((item: any) =>
            [item['id'], item])).values()]

          let jobInfor = {} as any
          let jobArray = [] as any
          for (let i = 0; i < state.jobSearch.data.length; i++) {
            jobInfor = state.jobSearch.data[i].item
            jobInfor.forEach((a: any) => {
              let array = jobInfor.filter((b: any) => {
                return (a.job_middle_code === b.job_middle_code)
              })
              jobArray.push({ item: [...array], id: a.job_middle_code, name: a.job_middle_name, nameMajor: a.job_major_name })
            })
            jobInfor = [...new Map(jobArray.map((item: any) =>
              [item['id'], item])).values()]
          }
          let jobInforArray = [] as any

          jobInfor.forEach((a: any) => {
            let array = jobInfor.filter((b: any) => {
              return (a.nameMajor === b.nameMajor)
            })
            let panel1 = [] as any
            state.jobSearch.selected.map((item: any, index: any) => {
              if (item.job_major_code === a.id.slice(0, 3)) {

                panel1.push(Number(item.job_middle_code.slice(5, 6)))
              }
            })
            panel1.filter((item: any, index: any) => {
              return panel1.indexOf(item) === index
            })
            if (panel1.length > 0) {
              panel1.unshift(0)
            }
            jobInforArray.push({ item: [...array], id: a.id, name: a.nameMajor, panel: panel1 })
          })
          jobInfor = [...new Map(jobInforArray.map((item: any) =>
            [item['name'], item])).values()]
          state.jobSearch.data = jobInfor
        })
        .then(() => {
          
        });
    },

    async renderJobSkillSelect() {
      await axiosinstance
        .get(
          "customer/v0/skill",
          {
            headers: {
              "content-type": "application/json",
            }
          }
        )
        .then(response => {
          state.skillSearch.allSkill = response.data
          state.skillSearch.data = response.data
          let skillData = [] as any
          state.skillSearch.data.forEach((a: any) => {
            let array = state.skillSearch.data.filter((b: any) => {
              return (a.major_code === b.major_code)
            })
            skillData.push({ item: [...array], id: a.major_code, name: a.major_name })
          })
          state.skillSearch.data = [...new Map(skillData.map((item: any) =>
            [item['id'], item])).values()]
        })
        .then(() => {
        });
    },

    async renderFeatureSelect() {
      await axiosinstance
        .get(
          "customer/v0/feature",
          {
            headers: {
              "content-type": "application/json",
            }
          }
        )
        .then(response => {
          state.featureSearch.data = response.data
          state.featureSearch.allFeature = response.data
          let featureData = [] as any
          state.featureSearch.data.forEach((a: any) => {
            let array = state.featureSearch.data.filter((b: any) => {
              return (a.major_code === b.major_code)
            })
            featureData.push({ item: [...array], id: a.major_code, name: a.major_name })
          })
          state.featureSearch.data = [...new Map(featureData.map((item: any) =>
            [item['id'], item])).values()]
        })
        .then(() => {
        });
    },

  }
}

export type CompanyRecruitmentStore = ReturnType<typeof companyRecruitmentStore>;
